import React from 'react';
import { Fade } from 'react-awesome-reveal';

import './style.scss';

const ParagraphAuthor = ({ entity }) => {
  const author = entity.getIn(['field_author', 0, 'value']);
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <Fade triggerOnce bottom distance="50px" duration={500} className="Paragraph">
      <div id={paragraphKey} className="ParagraphAuthor">
        <div className="ParagraphAuthor__written_by">Geschreven door</div>
        <div className="ParagraphAuthor__author">{author}</div>
      </div>
    </Fade>
  );
};

export default ParagraphAuthor;
